import { useEffect, useState } from 'react';
import { useGetUserQuery } from '~/services/user';

export default function usePayrixMerchantId() {
  const { data: userData, isPending: isUserDataPending } = useGetUserQuery();

  const [merchantId, setMerchantId] = useState('');
  const [isPending, setIsPending] = useState(true);

  useEffect(() => {
    if (userData) {
      if (!isUserDataPending) {
        const merchantId = userData?.locations?.[0]?.payrix_merchant_id; // 't1_mer_6570f1d21be940141510a94';
        setMerchantId(merchantId ?? '');

        setIsPending(false);
      } else {
        setIsPending(true);
      }
    }
  }, [userData, isUserDataPending]);

  return { merchantId, isPending };
}
